export default function DeliveryOverviewCards({ settings, zones }) {
  const cards = [
    ["Delivery Status", settings?.delivery_enabled ? "Enabled" : "Disabled"],
    ["Free Delivery Radius", `${settings?.free_delivery_radius_minutes ?? 0} minutes`],
    ["Minimum Notice", `${settings?.minimum_notice_days ?? 0} days`],
    ["Active Delivery Zones", `${zones.filter((zone) => zone.is_active).length} zones`],
  ];
  return <div className="delivery-overview-grid">{cards.map(([label, value]) => <article key={label} className="delivery-overview-card"><span>{label}</span><strong>{value}</strong></article>)}</div>;
}
